import {SimStats} from "./SimStats";

export class SimPlayerInfo extends SimStats{
	level:number;
	curHealth:number;
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/calculation/SimPlayerInfo.ts